import { RepositoryFabric } from "@api/repositories/RepositoryFabric";
import { ObjectRepository } from "@api/repositories/ObjectRepository";
import { MScheduleSlot } from "@api/models/meetings-schedule/MeetingsScheduleSlot";

import { scheduleSlotSchemaId, scheduleSchemaId } from "@share/meetings-schedule/types/SchemaIds";
import { MeetingsSchedule } from "@api/models/meetings-schedule/MeetingsSchedule";

export interface AppointmentDataLoaderInterface {
    loadSchedule(scheduleId: string): Promise<MeetingsSchedule | undefined>;
    loadSlots(scheduleId: string): Promise<MScheduleSlot[] | undefined>;
    loadSlotByUserId(scheduleId: string, userId: number): Promise<MScheduleSlot | undefined>;
}

export class AppointmentDataLoader implements AppointmentDataLoaderInterface {
    private objectRepository: ObjectRepository;

    constructor(repositories: RepositoryFabric) {
        this.objectRepository = repositories.get(RepositoryFabric.OBJECT) as ObjectRepository;
    }

    async loadSchedule(scheduleId: string) {
        try {
            const result = new MeetingsSchedule(await this.objectRepository.find({
                schema: scheduleSchemaId,
                objectId: scheduleId
            }));

            return result;
        }
        catch (error) {
            console.dir(error);
        }
    }

    async loadSlots(scheduleId: string) {
        try {
            const response = await this.objectRepository.query(scheduleSlotSchemaId, {
                take: -1,
                where: {
                    scheduleId: {
                        $eq: scheduleId
                    }
                },
                // include: ["id", "userIds", "parentId", "meetingsId", "isIndividual", "slotSize", "eventId", "from", "to"],
                order: {
                    beginAt: 'asc'
                }
            })

            return response.map((source) => new MScheduleSlot(source));
        }
        catch (error) {
            console.error(error);
        }
    }

    async loadSlotByUserId(scheduleId: string, userId: number) {
        try {
            const response = await this.objectRepository.query(scheduleSlotSchemaId, {
                take: -1,
                where: {
                    scheduleId: {
                        $eq: scheduleId
                    },
                    ownerIds: {
                        $containsAny: [userId]
                    }
                },
                // include: ["id", "userIds", "parentId", "meetingsId", "isIndividual", "slotSize", "eventId", "from", "to"],
                order: {
                    beginAt: 'asc'
                }
            })

            if(response.length > 0) {
                return new MScheduleSlot(response[0]);
            }
        }
        catch (error) {
            console.error(error);
        }
    }
}
